/**
 * Seules les URL web absolues peuvent devenir des hyperliens cliquables.
 * `URL` accepte aussi `javascript:`, `data:` ou `ftp:` ; vérifier uniquement
 * que le constructeur ne jette pas laisserait donc passer du contenu actif.
 */
export function estUrlWebSure(value: string): boolean {
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}
